interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
  align?: "left" | "center";
}

const SectionHeader = ({ title, subtitle, className = "", align = "center" }: SectionHeaderProps) => {
  return (
    <div className={`mb-12 ${align === "center" ? "text-center" : "text-left"} ${className}`}>
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-display tracking-widest text-foreground amber-underline inline-block">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-6 text-muted-foreground text-lg max-w-2xl mx-auto font-body">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
